import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossierHistorical/${dossierId}/entitychild`, method: 'GET', token: token })
}
